





















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ModuleStepListStepDefaultTab from '@/views/ModulePage/ModuleStepListStepDefaultTab.vue';
import ModuleStepListStepTimeTab from '@/views/ModulePage/ModuleStepListStepTimeTab.vue';
import ModuleStepListStepResponsibleTab from '@/views/ModulePage/ModuleStepListStepResponsibleTab.vue';
import { Step } from '@/interfaces/Step';
import { Module } from '@/interfaces/Module';
import ModuleStepListStepRequiresTab from '@/views/ModulePage/ModuleStepListStepRequiresTab.vue';
import ModuleStepListStepAttributesTab from '@/views/ModulePage/ModuleStepListStepAttributesTab.vue';
import { Environment } from '@/interfaces/Environment';
import { EnvironmentChangesStep } from '@/interfaces/EnvironmentChangesStep';

@Component({
  components: {
    ModuleStepListStepAttributesTab,
    ModuleStepListStepRequiresTab,
    ModuleStepListStepResponsibleTab,
    ModuleStepListStepTimeTab,
    ModuleStepListStepDefaultTab
  }
})
export default class ModuleStepListStep extends Vue {
  private tab = 0;

  @Prop({ default: () => ({}) })
  step!: Step;

  @Prop({ default: () => ({}) })
  module!: Module;

  @Prop()
  defaultTab!: number;

  @Prop()
  selectedEnvironment!: number | null;

  @Prop()
  environmentSteps!: Step[];

  private hasEnvironmentSpecificStep = true;

  @Prop()
  enabled!: boolean;

  get enabledForEnvironment() {
    if (!this.environmentEnvironmentStep) throw new Error('env step not found');
    return this.environmentEnvironmentStep.enabled;
  }

  set enabledForEnvironment(value: number) {
    const envStep = this.environmentEnvironmentStep;
    if (envStep) envStep.enabled = value;
  }

  get environmentColor() {
    return (
      this.$store.state.all_environments.find(
        (environment: Environment) => environment.id === this.selectedEnvironment
      )?.color || '#FFF'
    );
  }

  get environmentEnvironmentStep(): EnvironmentChangesStep | undefined {
    const environmentStep = this.environmentSteps.find((envStep) => envStep.id === this.step.id);

    return environmentStep?.environments.find(
      (stepEnvironment) => stepEnvironment.environment_id === this.selectedEnvironment
    );
  }

  get stepName() {
    const { languageId } = this.$store.state.user;
    const environmentStepLanguage = this.environmentStep.stepLanguages?.find(
      (stepLanguage) => stepLanguage.languageId === languageId
    );
    const stepLanguage = this.step.stepLanguages?.find((sL) => sL.languageId === languageId);

    return environmentStepLanguage?.name || stepLanguage?.name || '';
  }

  get environmentStep() {
    if (!this.selectedEnvironment) {
      this.hasEnvironmentSpecificStep = true;
      return this.step;
    }

    const environmentStepCorrectEnvironment = this.environmentEnvironmentStep?.change;
    this.hasEnvironmentSpecificStep = !!environmentStepCorrectEnvironment;
    return environmentStepCorrectEnvironment || this.step;
  }

  get restrictedUser() {
    return !this.$store.state.user.permissions.cutovertool.admin;
  }
}
